import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';
import { CutOffTimeEnum } from '@nttp/enum/cut-off-time.enum';

@Injectable({
  providedIn: 'root'
})

export class TransactionForm {
  valueDateString: string;
  inputDateString: string;
  soldOfferInfo: {
    currencyId: string,
    quantity: Number,
    currencyCode: string,
  };
  boughtOfferInfo: {
    currencyId: string,
    quantity: Number
    currencyCode: string,
  };
  exchangeRate: Number;
}

@Injectable({
  providedIn: 'root'
})
export class FundAccountService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  /**
   * @method toFasterPayment
   * @description push data of transaction confirmation screen
   */
  public toFasterPayment(transactionForm: any): Observable<any> {
    return this.http.post(`${this.api}`, transactionForm);
  }

  /**
   * @method getCurrencyRate
   * @description get currency date for change
   */
  public getCurrencyRate(convert: string): Observable<any> {
    return this.http.get(`${this.api}/trade/get-realtime-rate/${convert}`);
  }

  /**
   * getTransaction
   */
  public getTransaction(form: TransactionForm): Observable<any> {
    return this.http.post(`${this.api}/trade/insert-trade`, form);
  }

  /**
   * getFasterPayment
   */
  public getFasterPayment(payCurrencyId: string): Observable<any> {
    return this.http.get(`${this.api}/trade/get-default-privalgo-bank/${payCurrencyId}`);
  }

  public downloadPDF(params): Observable<any> {
    return this.http.post(`${this.api}/trade/show-pdf`, params, { responseType: 'blob' });
  }

  public getDeposited(): Observable<any> {
    return this.http.get(`${this.api}/customer/get-deposited`, { responseType: 'text' });
  }

  public sendEmailQuoteAlerts(form: any): Observable<any> {
    return this.http.post(`${this.api}/trade/send-quote-alerts`, form);
  }

  /* BEGIN === Integrated Online Transfer (IOT) === */
  public getIsIOTPermitted(param: any): Observable<any> {
    return this.http.post(`${this.api}/iot/get-is-iot-permitted`, param, {
      responseType: 'text',
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  public getIOTCountries(queryString: string): Observable<any> {
    return this.http.get(`${this.api}/iot/get-countries?${queryString}`);
  }

  public getIOTBanks(queryString: string): Observable<any> {
    return this.http.get(`${this.api}/iot/get-banks?${queryString}`);
  }

  public initiateIOTPayment(param: any): Observable<any> {
    return this.http.post(`${this.api}/iot/initiate-payment`, param, {
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  public getTradeAfterIOT(ourPaymentRef: string): Observable<any> {
    return this.http.get(`${this.api}/trade/get-trade-after-iot/${ourPaymentRef}`);
  }

  public postIOTPayment(param: any): Observable<any> {
    return this.http.post(`${this.api}/iot/update-payment`, param);
  }

  public postProcessCallback(query: any): Observable<any> {
    return this.http.post(`${this.api}/iot/process-callback`, query, {
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  public postLogMessage(param: any): Observable<any> {
    return this.http.post(`${this.api}/iot/log-message`, param);
  }
  /* END === Integrated Online Transfer (IOT) === */

  public checkSameDayCutOff(): Observable<any> {
    return this.http.get(`${this.api}/trade/check-cut-off-time/${CutOffTimeEnum.Sameday}`);
  }

  public getTradeTypeByCurrencyPair(params): Observable<any> {
    return this.http.post(`${this.api}/customer/get-allowed-trade-types-for-currency-pair`, params);
  }

  public forwardTradesCheckWithTradeType(params): Observable<any> {
    return this.http.post(`${this.api}/trade/forward-trades-check-with-trade-type`, params);
  }
}
